import { render, staticRenderFns } from "./Fixedfooter.vue?vue&type=template&id=55501dbf&"
import script from "./Fixedfooter.vue?vue&type=script&lang=js&"
export * from "./Fixedfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports